module.exports = __webpack_public_path__ + "static/media/menu_icon_locomo_normal.cf592b4a.png";